import React from "react";
import { NavLink } from "react-router-dom";

const itemNameIcon = (props) => {
  return props.isTag ? (
      <div className="text-col-1">
        <img className="pr-2" src={props.itemIcon} alt="Tag" />
        {props.item.title}
      </div>
    ) : props.isArchivedView ? (
    !props.item.rootId ? (
      <NavLink to={`/archives/${props.item.id}`}>
        <div className="text-col-1">
          <img className="pr-2" src={props.itemIcon} alt="Folder Primary" />
          {props.isFolder
            ? props.item.title || props.item.parentTitle
            : props.item.document.title}
        </div>
      </NavLink>
    ) : props.item.rootId && !props.item.file ? (
      <NavLink to={`/archives/${props.item.rootId}/${props.item.parentId}`}>
        <div className="text-col-1">
          <img className="pr-2" src={props.itemIcon} alt="Folder Primary" />
          {props.isFolder
            ? props.item.title || props.item.parentTitle
            : props.item.document.title}
        </div>
      </NavLink>
    ) : (
      <div className="text-col-1" onClick={() => props.onClick(props.item.id)}>
        <img className="pr-2" src={props.itemIcon} alt="Folder Primary" />
        {props.isFolder
          ? props.item.title || props.item.parentTitle
          : props.item.document.title}
      </div>
    )
  ) : props.isFolder ? (
    props.item.isRoot ? (
      <NavLink to={`/files/${props.rootFolderId}`}>
        <div className="text-col-1">
          <img className="pr-2" src={props.itemIcon} alt="Folder Primary" />
          {props.item.title}
        </div>
      </NavLink>
    ) : (
      <NavLink to={`/files/${props.rootFolderId}/${props.subFolderId}`}>
        <div className="text-col-1">
          <img className="pr-2" src={props.itemIcon} alt="Folder Primary" />
          {!props.isGrid ? props.item.title : ""}
        </div>
      </NavLink>
    )
  ) : (
    <div
      className="text-col-1"
      style={{ cursor: "pointer" }}
      onClick={() =>
        props.recentlyEditedView
          ? props.onDocumentClick(props.item.id)
          : props.onClick(props.item.id)
      }
    >
      <img className="pr-2" src={props.itemIcon} alt="Folder Primary" />
      {props.item.title}
    </div>
  );
};

export default itemNameIcon;
